import { render, staticRenderFns } from "./UserItemRate.vue?vue&type=template&id=416a1714&scoped=true&"
import script from "./UserItemRate.vue?vue&type=script&lang=js&"
export * from "./UserItemRate.vue?vue&type=script&lang=js&"
import style0 from "./UserItemRate.vue?vue&type=style&index=0&id=416a1714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416a1714",
  null
  
)

export default component.exports